import { LOCAL_TIME_ZONE } from "constants/globalConstants";

export const baseLineModalObj = {
  Title: "",
  BaselineValuesSetting: "timestamp",
  Timezone: LOCAL_TIME_ZONE,
  Date: "",
  TimeStamp: "",
  NormalizationTags: {
    PT2: {
      label: "PT 2",
      value: "",
      tagName: "PT2",
      tagId: "TAG077",
      tag: null
    },
    CIT1: {
      label: "CIT 1",
      value: "",
      tagName: "CIT1",
      tagId: "TAG086",
      tag: null
    },
    FIT1: {
      label: "FIT 1",
      value: "",
      tagName: "FIT1",
      tagId: "TAG071",
      tag: null
    },
    AIT1: {
      label: "AIT 1",
      value: "",
      tagName: "AIT1",
      tagId: "TAG083",
      tag: null
    },
    PT3: {
      label: "PT 3",
      value: "",
      tagName: "PT3",
      tagId: "TAG078",
      tag: null
    },
    CIT2: {
      label: "CIT 2",
      value: "",
      tagName: "CIT2",
      tagId: "TAG087",
      tag: null
    },
    FIT2: {
      label: "FIT 2",
      value: "",
      tagName: "FIT2",
      tagId: "TAG072",
      tag: null
    },
    Last_CCD_VR: {
      label: "Last CCD VR",
      value: "",
      tagName: "Last_CCD_VR",
      tagId: "TAG044",
      tag: null
    },
    Volumetric_Recovery: {
      label: "V. Recovery",
      value: "",
      tagName: "Volumetric_Recovery",
      tagId: "TAG034",
      tag: null
    },
    CIT3: {
      label: "CIT 3",
      value: "",
      tagName: "CIT3",
      tagId: "TAG088",
      tag: null
    },
    FIT3: {
      label: "FIT 3",
      value: "",
      tagName: "FIT3",
      tagId: "TAG033",
      tag: null
    },
    TT1: {
      label: "TT 1",
      value: "",
      tagName: "TT1",
      tagId: "TAG091",
      tag: null
    },
    M_DP: {
      label: "M DP",
      value: "",
      tagName: "M_DP",
      tagId: "TAG038",
      tag: null
    },
    PT7: {
      label: "PT 7",
      value: "",
      tagName: "PT7",
      tagId: "TAG080",
      tag: null
    }
  }
};
